import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/use-auth'
import { LogOut } from 'lucide-react'
import { Logo } from '@/components/ui/logo'

export function Header() {
  const { user, signOut } = useAuth()

  const handleSignOut = async () => {
    await signOut()
  }

  return (
    <header className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
           <a href="https://plusefin.com/" target="_blank" rel="noopener noreferrer">
            <Logo textClassName="text-gray-900" />
          </a>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="https://plusefin.com/docs/" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer">Documentation</a>
            <a href="https://plusefin.com/#pricing" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer">Pricing</a>
            {user && (
              <Link to="/dashboard" className="text-gray-600 hover:text-gray-900">Dashboard</Link>
            )}
          </nav>
          
          <div className="flex items-center space-x-4">
            {user ? (
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-600">Welcome, {user.email}</span>
                <Button variant="outline" size="sm" onClick={handleSignOut}>
                  <LogOut className="w-4 h-4 mr-2" />
                  Sign Out
                </Button>
              </div>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="outline" size="sm">
                    Log In
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
